export default __webpack_public_path__ + "4d04ec1e6eaaefab70d4a1a9962b0ca8.png";